import api, { unwrap } from './client';

export type ErpModule =
  | 'POS'
  | 'INVENTORY'
  | 'CRM'
  | 'LOYALTY'
  | 'REPORTING'
  | 'PROCUREMENT'
  | 'ANALYTICS'
  | 'PROJECTS'
  | 'HR'
  | 'FINANCE'
  | 'PAYROLL'
  | 'DELIVERY'
  | 'ECOMMERCE'
  | 'WAREHOUSE'
  | 'SOCIAL'
  | 'DESK'
  | 'LEAD_GEN'
  | 'MARKETING';

export interface OrganizationModuleDto {
  module: ErpModule;
  enabled: boolean;
}

export interface OrganizationFeatureDto {
  code: string;
  name: string;
  module: string;
  description?: string;
  enabled: boolean;
  locked: boolean;
}

export interface OrganizationSettingDto {
  uuid: string;
  settingKey: string;
  settingValue?: string;
}

export interface CompanyWorkflowGovernance {
  globalRequireWorkflows: boolean;
  moduleRequireWorkflows: Record<string, boolean>;
  allowOnBehalfAutoApprove: boolean;
}

export const platformApi = {
  listFeatures: () =>
    unwrap<OrganizationFeatureDto[]>(api.get('/v1/platform/features')),

  listModules: () =>
    unwrap<OrganizationModuleDto[]>(api.get('/v1/platform/modules')),

  listAccessibleModules: () =>
    unwrap<string[]>(api.get('/v1/platform/accessible-modules')),

  switchWorkspace: (module: string, deviceId?: string) =>
    unwrap<import('@/types/auth').LoginResponse>(
      api.post('/v1/platform/switch-workspace', { module, deviceId }),
    ),

  updateModule: (module: ErpModule, enabled: boolean) =>
    unwrap<OrganizationModuleDto>(
      api.put(`/v1/platform/modules/${module}`, { enabled }),
    ),

  listSettings: () =>
    unwrap<OrganizationSettingDto[]>(api.get('/v1/platform/settings')),

  upsertSetting: (settingKey: string, settingValue?: string) =>
    unwrap<OrganizationSettingDto>(
      api.put('/v1/platform/settings', { settingKey, settingValue }),
    ),

  getWorkflowGovernance: () =>
    unwrap<CompanyWorkflowGovernance>(api.get('/v1/platform/workflow-governance')),

  saveWorkflowGovernance: (body: Partial<CompanyWorkflowGovernance>) =>
    unwrap<CompanyWorkflowGovernance>(api.put('/v1/platform/workflow-governance', body)),
};
